export const getGrenacheBlancFranceData = () => ({
  name: "Grenache Blanc",
  country: "France",
  description: "Grenache Blanc est un cépage blanc originaire d'Espagne, largement cultivé dans le sud de la France où il produit des vins blancs riches et aromatiques.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "100 ha", percentage: "1%", description: "Cépage blanc principal pour les vins blancs" },
    { name: "Côtes du Rhône", area: "500 ha", percentage: "5%", description: "Cépage blanc important dans les assemblages" },
    { name: "Languedoc-Roussillon", area: "800 ha", percentage: "3%", description: "Cultivé dans de nombreuses appellations" },
    { name: "Provence", area: "300 ha", percentage: "2%", description: "Utilisé dans les rosés et vins blancs" },
    { name: "Autres", area: "200 ha", percentage: "1%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 2 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#6d2c7a", size: 3 },
    { region: "Languedoc", x: 48, y: 62, color: "#8a4a8a", size: 4 },
    { region: "Provence", x: 46, y: 60, color: "#a768a6", size: 2 }
  ],
  characteristics: {
    viticulture: "Cépage vigoureux, résistant à la sécheresse, sensible à l'oxydation",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    white: "Vins blancs riches et aromatiques avec des notes de fruits exotiques et de miel",
    rose: "Rosés aromatiques avec des notes de fruits rouges"
  },
  foodPairing: "Poissons gras, fruits de mer, volailles, fromages affinés, cuisine provençale",
  history: "Grenache Blanc est la version blanche du cépage Grenache, originaire d'Espagne. Il a été introduit dans le sud de la France il y a plusieurs siècles et s'est parfaitement adapté aux conditions climatiques locales. Il est aujourd'hui un cépage blanc majeur dans de nombreuses appellations du sud de la France."
}); 